export const AdminDeveloperDashboards = {
  AdminDeveloperDashboards: 
  {
    permissionsId:'f7f6b333-1988-4619-7971-08dcaf947ea8',
    permissionsName:'Admin Developer' , 
    componentsId:null,
    components:null
  }
} ;
